// extracted by mini-css-extract-plugin
export var dark = "headline-module--dark--cddc4";
export var headline = "headline-module--headline--1bf3a";
export var light = "headline-module--light--fc95c";